import { render, staticRenderFns } from "./AndiamoUtenteViewComponent.vue?vue&type=template&id=65d33131&scoped=true"
import script from "./AndiamoUtenteViewComponent.vue?vue&type=script&lang=js"
export * from "./AndiamoUtenteViewComponent.vue?vue&type=script&lang=js"
import style0 from "./AndiamoUtenteViewComponent.vue?vue&type=style&index=0&id=65d33131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d33131",
  null
  
)

export default component.exports